/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_No_Field_ChangesInputs */

const cs_ebr_no_field_changes = /** @type {(inputs: Ebr_No_Field_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné změny polí.`)
};

const en_ebr_no_field_changes = /** @type {(inputs: Ebr_No_Field_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No field changes.`)
};

/**
* | output |
* | --- |
* | "No field changes." |
*
* @param {Ebr_No_Field_ChangesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_no_field_changes = /** @type {((inputs?: Ebr_No_Field_ChangesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_No_Field_ChangesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_no_field_changes(inputs)
	return cs_ebr_no_field_changes(inputs)
});